import React from "react";
import { Button } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import theme from '../Theme'
import {
  SafetyCertificateOutlined,
  ClockCircleOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import CompostOutlinedIcon from '@mui/icons-material/CompostOutlined';
import { useNavigate } from "react-router-dom";

const Banner1: React.FC = () => {
    const navigate = useNavigate();
  return (
    <>
        <div className="py-5 px-3"
        style={{
            backgroundColor:theme.color.bg
        }}>
            <Container className="pb-5">
                <Row className="align-items-center">
                <Col md={6} className="text-center text-md-start mb-4 mb-md-0 pe-md-2">
                <h1 className="fw-bold display-5">
                    Premium <span className="" style={{color:theme.color.pri}}>Fresh Meat</span>
                    <br />
                    <span className="">
                    Delivered to Your Door
                    </span>
                </h1>
                <p className=" mt-3">
                    100% Halal, Organic, and Fresh. Experience the finest quality meat
                    with 25+ years of trusted service and same-day delivery.
                </p>

                <div className="d-flex gap-3 justify-content-center justify-content-md-start mt-4">
                    <Button size="large" className="custom-btn shbtn" style={{backgroundColor:theme.color.pri, color:theme.color.whi}} onClick={()=>navigate("/all-categories")}>
                    Shop now →
                    </Button>
                    {/* <Button size="large"  className="custom-btn vcbtn">View Combo</Button> */}
                </div>
                </Col>
                <Col md={6} className="text-center ps-md-2">
                <img
                    src="/assets/meatbn1.jpg"
                    alt="Fresh Meat"
                    className="img-fluid rounded"
                />
                </Col>
            </Row>
            </Container>
        </div>
        <div className=" py-5">
            <Container>
            <Row className="text-center gy-4">
                <Col md={3} sm={6}>
                    <div>
                    <div
                        style={{
                        backgroundColor: theme.color.pri,
                        width: "60px",
                        height: "60px",
                        margin: "0 auto 15px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.color.whi,
                        fontSize: "24px",
                        }}
                    >
                        <SafetyCertificateOutlined />
                    </div>
                    <h5 className="fw-bold">100% Halal Meat</h5>
                    <p className="text-muted small">
                        Certified halal with strict quality standards
                    </p>
                    </div>
                </Col>

                <Col md={3} sm={6}>
                    <div>
                    <div
                        style={{
                        backgroundColor: theme.color.pri,
                        width: "60px",
                        height: "60px",
                        margin: "0 auto 15px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.color.whi,
                        fontSize: "24px",
                        }}
                    >
                        <ClockCircleOutlined />
                    </div>
                    <h5 className="fw-bold">20+ Years Experience</h5>
                    <p className="text-muted small">
                        Trusted by families for over two decades
                    </p>
                    </div>
                </Col>

                <Col md={3} sm={6}>
                    <div>
                    <div
                        style={{
                        backgroundColor: theme.color.pri,
                        width: "60px",
                        height: "60px",
                        margin: "0 auto 15px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.color.whi,
                        fontSize: "24px",
                        }}
                    >
                        {/* <LeafOutlined /> */}
                        <CompostOutlinedIcon/>
                    </div>
                    <h5 className="fw-bold">Proudly 100% Organic</h5>
                    <p className="text-muted small">
                        No hormones, no antibiotics, just natural
                    </p>
                    </div>
                </Col>

                <Col md={3} sm={6}>
                    <div>
                    <div
                        style={{
                        backgroundColor: theme.color.pri,
                        width: "60px",
                        height: "60px",
                        margin: "0 auto 15px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.color.whi,
                        fontSize: "24px",
                        }}
                    >
                        <HeartOutlined />
                    </div>
                    <h5 className="fw-bold">100% Fresh Meat</h5>
                    <p className="text-muted small">
                        Daily fresh cuts, never frozen
                    </p>
                    </div>
                </Col>
            </Row>
            </Container>
        </div>
    </>
  );
};

export default Banner1;
